/**
 * Conditional analytics wrapper
 * Provides safe wrappers for analytics services that are blocked in China
 */

import posthog from "posthog-js";
import { shouldLoadAnalytics } from "./chinaDetection";

/**
 * Safe PostHog wrapper that only executes if analytics should be loaded
 */
export const safePosthog = {
  init: (...args) => {
    if (shouldLoadAnalytics()) {
      return posthog.init(...args);
    }
    console.log("[Analytics] PostHog init skipped (China region detected)");
  },

  capture: (...args) => {
    if (shouldLoadAnalytics()) {
      return posthog.capture(...args);
    }
  },

  identify: (...args) => {
    if (shouldLoadAnalytics()) {
      return posthog.identify(...args);
    }
  },

  reset: (...args) => {
    if (shouldLoadAnalytics()) {
      return posthog.reset(...args);
    }
  },

  group: (...args) => {
    if (shouldLoadAnalytics()) {
      return posthog.group(...args);
    }
  },

  alias: (...args) => {
    if (shouldLoadAnalytics()) {
      return posthog.alias(...args);
    }
  },

  people: {
    set: (...args) => {
      if (shouldLoadAnalytics()) {
        return posthog.people?.set(...args);
      }
    },
  },
};

/**
 * Safe Facebook Pixel wrapper
 */
export const safeFbq = (...args) => {
  if (shouldLoadAnalytics() && typeof window.fbq === "function") {
    return window.fbq(...args);
  }
};

/**
 * Safe TikTok Pixel wrapper
 */
export const safeTtq = (...args) => {
  if (shouldLoadAnalytics() && typeof window.ttq === "function") {
    return window.ttq(...args);
  }
};

/**
 * Check if Google Tag Manager is loaded
 */
export const isGTMLoaded = () => {
  return shouldLoadAnalytics() && typeof window.dataLayer !== "undefined";
};
